import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RapportsRembourse } from 'model/modal-cms/rapport_activite_remb';
import { CMSService } from '../../../services/cms-service';
import Swal from 'sweetalert2'
import { RapportsRemboursSLCTSZ } from 'model/modal-cms/rapport_activite_remb_slc';
declare var mdtoast: any;
var success_message = mdtoast('Opération effectué avec succès.', { duration: 5000, init: true, type: mdtoast.SUCCESS });
var error_message = mdtoast('Opération non effectué.', { duration: 5000, init: true, type: mdtoast.ERROR });
var info_message = mdtoast('Opération non effectué. Ce donnée est en cours d\'utilisation.', { duration: 5000, init: true, type: mdtoast.INFO });
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { AdminService } from '../../../services/admin';

@Component({
  selector: 'app-rapport-activiter-rembourse',
  templateUrl: './rapport-activiter-rembourse.component.html',
  styleUrls: ['./rapport-activiter-rembourse.component.scss']
})
export class RapportActiviterRembourseComponent implements OnInit {
  id: any;
  etat_actuel: any;
  mode_rembours: number = 1;
  rapportsRembourse: RapportsRembourse = new RapportsRembourse(null);
  rapportsRemboursSLCTSZ: RapportsRemboursSLCTSZ = new RapportsRemboursSLCTSZ(null);
  fileToUmpload: File = null;
  urlServer = environment.urlServerphoto;
  imageUrl: any
  id_agent_actuel: any;

  name: any = ""
  rembourseSecDAF161: any;
  rembourseSLCTSZ: any;
  constructor(public activatedRoute: ActivatedRoute, public adminService: AdminService, public cmsService: CMSService, private http: HttpClient, ) {
    this.id = activatedRoute.snapshot.params['id'];
    this.id_agent_actuel = this.adminService.getUserIMIscrit();

  }

  ngOnInit() {
    if (this.id == 2) {
      this.mode_rembours = 2;
      this.name = "Rapport des dossiers traités aux validateurs juridiques."
      this.etat_actuel = "VJ"
      this.getRapportActiviteRembourseSLCTSZ();
    } else if (this.id == 3) {
      this.etat_actuel = "VA"
      this.mode_rembours = 3;
      this.name = "Rapport des dossiers traités aux validateurs administratifs."
      this.getRapportActiviteRembourseSLCTSZ();
    } else if (this.id == 4) {
      this.mode_rembours = 3;
      this.name = "Rapport des dossiers traités au  validateur médical."
      this.etat_actuel = "VM"
      this.getRapportActiviteRembourseSLCTSZ();
    } else if (this.id == 5) {
      this.mode_rembours = 3;
      this.name = "Rapport des dossiers validé ou rejeté au  Chef CMS."
      this.etat_actuel = "VCHEF"
      this.getRapportActiviteRembourseSLCTSZ();
    } else if (this.id == 1 || this.id == 8) {
      this.mode_rembours = 1;
      this.name = "Rapport des dossiers enregistrés au niveau de la DAF."
      this.etat_actuel = "SEC_DAF"
      this.getRapportActiviteRembourseSecDAF161();
    } else if (this.id == 6) {
      this.mode_rembours = 1;
      this.name = "Rapport des dossiers engagé."
      this.etat_actuel = "161_E"
      this.getRapportActiviteRembourseSecDAF161();
    } else if (this.id == 7) {
      this.mode_rembours = 1;
      this.name = "Rapport des dossiers ordonnancé."
      this.etat_actuel = "161_O"
      this.getRapportActiviteRembourseSecDAF161();
    }
  }

  getRapportActiviteRembourseSecDAF161() {
    this.cmsService.getRaportActiviteRembourseSecDAF161(this.etat_actuel)
      .subscribe(data => {
        this.rembourseSecDAF161 = data
        console.log("sec daf" + data)
      },
        err => {
          console.log(err);
        })
  }

  getInfoRembourseSecDAF161(id_rap: number) {
    this.cmsService.getInfoRaportRembourseSecDAF161(id_rap)
      .subscribe(data => {
        this.rapportsRembourse = data
      },
        err => {
          console.log(err);
        })
  }

  getInfoRembourseSLCTSZ(id_rap: number) {
    this.cmsService.getInfoRaportRembourseSLCTSZ(id_rap)
      .subscribe(data => {
        this.rapportsRemboursSLCTSZ = data
      },
         err => {
          console.log(err);
        })
  }

  //upload  file MED
  onChangeSelectFile(file: FileList) {
    this.fileToUmpload = file.item(0);
    console.log(this.fileToUmpload);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.imageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUmpload);
  }

  //uplod logo IEC
  enregistrerFileRebSec161() {
    const uploadData = new FormData();
    uploadData.append('avatar', this.fileToUmpload, this.fileToUmpload.name);
    this.http.post(this.urlServer + 'uploadFichierRapRembourse.php', uploadData, {
      reportProgress: true,
      observe: 'events'
    })
      .subscribe(event => {
        console.log(event);
      }
      )
  }



  saveRapportRembourseSecDAF161() {
    this.rapportsRembourse.responsable = this.id_agent_actuel;
    if (this.rapportsRembourse.id_rap_remb == null) {
      this.rapportsRembourse.etat = this.etat_actuel;
      if (this.fileToUmpload == null) {
        this.rapportsRembourse.fichier = "undefind";
      } else {
        this.rapportsRembourse.fichier = this.fileToUmpload.name
      }
      console.log(this.rapportsRembourse);
      this.cmsService.saveRaportRembourseSecDAF161(this.rapportsRembourse).subscribe(data => {
        if (data.err) {
          //toastr.error(data.err);return;
        }

        if (this.fileToUmpload != null) {
          this.enregistrerFileRebSec161();
        }
        this.getRapportActiviteRembourseSecDAF161();
        this.rapportsRembourse = new RapportsRembourse(null)
        success_message.show();
      }, err => {
        error_message.show();
      })
    } else {
      if (this.fileToUmpload == null) {
      } else {
        this.rapportsRembourse.fichier = this.fileToUmpload.name
        this.enregistrerFileRebSec161();
      }
      this.rapportsRembourse.responsable = this.id_agent_actuel;
      this.cmsService.updateRaportRembourseSecDAF161(this.rapportsRembourse).subscribe(data => {
        if (data.err) {
          //toastr.error(data.err);return;
        }
        this.getRapportActiviteRembourseSecDAF161();
        this.rapportsRembourse = new RapportsRembourse(null)
        success_message.show();
      }, err => {
        error_message.show();
      })
    }

  }


  DeleteRembourseSecDAF161(r: RapportsRembourse) {
    Swal.fire({
      title: 'Êtes-vous sûr de supprimer?',
      text: "Une fois que vous cliquez sur Ok, vous ne pouvez plus revenir en arrière.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        this.cmsService.deleteRaportRembourseSecDAF161t(r.id_rap_remb)
          .subscribe(data => {
            this.getRapportActiviteRembourseSecDAF161();
            success_message.show();
          }, err => {
            console.log('erreur de supression');
          })
      }
    })
  }


  //SLC & TSZ
  getRapportActiviteRembourseSLCTSZ() {
    this.cmsService.getRaportActiviteRembourseSLCTSZ(this.etat_actuel)
      .subscribe(data => {
        this.rembourseSLCTSZ = data
      },
        err => {
          console.log(err);
        })
  }





  saveRapportRembourseSLC() {
    this.rapportsRemboursSLCTSZ.responsable = this.id_agent_actuel;
    if (this.rapportsRemboursSLCTSZ.id_rembourse_slc == null) {
      this.rapportsRemboursSLCTSZ.etat_slc = this.etat_actuel;
      if (this.fileToUmpload == null) {
        this.rapportsRemboursSLCTSZ.fichier_slc = "undefind";
      } else {
        this.rapportsRemboursSLCTSZ.fichier_slc = this.fileToUmpload.name
      }

      console.log(this.rapportsRemboursSLCTSZ);
      this.cmsService.saveRapportRembourseSLC(this.rapportsRemboursSLCTSZ).subscribe(data => {
        if (data.err) {
          //toastr.error(data.err);return;
        }
        if (this.fileToUmpload != null) {
          this.enregistrerFileRebSec161();
        }
        this.getRapportActiviteRembourseSLCTSZ();
        this.rapportsRemboursSLCTSZ = new RapportsRemboursSLCTSZ(null)
        success_message.show();
      }, err => {
        error_message.show();
      })
    } else {
      if (this.fileToUmpload == null) {

      } else {
        this.rapportsRemboursSLCTSZ.fichier_slc = this.fileToUmpload.name
        this.enregistrerFileRebSec161();
      }
      this.rapportsRemboursSLCTSZ.responsable = this.id_agent_actuel;
      this.cmsService.updateRapportRembourseSLC(this.rapportsRemboursSLCTSZ).subscribe(data => {
        if (data.err) {
          //toastr.error(data.err);return;
        }
        this.getRapportActiviteRembourseSLCTSZ();
        this.rapportsRemboursSLCTSZ = new RapportsRemboursSLCTSZ(null)
        success_message.show();
      }, err => {
      })
    }

  }

}
